import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import "./index.css";
import { ThemeProvider } from "./context/ThemeContext";

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
